import { render, staticRenderFns } from "./ProductListing.vue?vue&type=template&id=70732f96&"
import script from "./ProductListing.vue?vue&type=script&lang=js&"
export * from "./ProductListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70732f96')) {
      api.createRecord('70732f96', component.options)
    } else {
      api.reload('70732f96', component.options)
    }
    module.hot.accept("./ProductListing.vue?vue&type=template&id=70732f96&", function () {
      api.rerender('70732f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductListing.vue"
export default component.exports